//
// Copyright 2020 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import Switch from "@material-ui/core/Switch";
import ConfigurationCheckBox from "./ConfigurationCheckBox";

/**
 * Configuration component for a boolean value.
 * @param path - configuration path which uniquely identifies the configuration value bound to this component
 */
var ConfigurationSwitch = function ConfigurationSwitch(props) {
  return /*#__PURE__*/React.createElement(ConfigurationCheckBox, Object.assign({
    component: Switch
  }, props));
};
export default ConfigurationSwitch;